import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../redux/actions/userActions";
import jwt_decode from "jwt-decode";
import { useHistory, Link, useLocation, NavLink } from "react-router-dom";
import logo1 from "../../assets/img/logo1.png";
import "./Navbar";


const Footer = () => {
  // const userState = useSelector(state=>state.loginUserReducer)
  // const {currentUser} = userState;

  const [navLinkOpen, navLinkToggle] = useState(false);
  const history = useHistory();

  // var decoded = jwt_decode(currentUser);

  const handleNavlinkToggle = () => {
    navLinkToggle(!navLinkOpen);
  };

  const dispatch = useDispatch();
  const logOut = () => {
    dispatch(logoutUser()).then(() => {
      history.push("/login");
    });
  };

  const renderClasses = () => {
    let classes = "navlinks";
    if (navLinkOpen) {
      classes += " active";
    }
    return classes;
  };
  return (
    <div className="mt-5">
      <footer>

        <div className="section bg-secondary">
          <div className="container">
            <div className="row justify-content-between">

              <div className="col-lg-5 mb-5 mb-lg-0">

                <a className="mb-4 d-inline-block" href="index.html">
                  <img className="img-fluid" style={{ height: '10rem', width: '10rem' }} src={logo1} alt=" V3 Data Intelligence" />
                </a>
                <p className="text-light" style={{ textAlign: 'justify' }} > V3 Data Intelligence is a global marketing technology company serving the world’s leading agencies and brands, including Airbnb, Dell EMC and Lexus.  V3 Data Intelligence patented Brand Intelligence technology measures digital engagement to provide a deeper understanding of audiences, their mindset and interests.</p>
                {/* 
                <h4 className="text-white mb-4">Follow Us On</h4>

                <ul className="list-inline social-icon-alt">
                  <li><a href="https://www.linkedin.com/company/v3-data-intelligence-pvt-ltd/" target="_blank"><i className="fa fa-linkedin"></i></a></li>
                </ul> */}

              </div>
              <div className="col-lg-6">
                <div className="row">

                  <div className="col-6 mb-5">
                    <h4 className="text-white mb-4" style={{ fontSize: '1.7rem' }}>Services</h4>
                    <ul className="list-styled">
                      <li className="mb-3 text-light"><a className="text-light d-block" href="https://www.v3dataintel.com/home/about.html">Company History</a></li>
                      <li className="mb-3 text-light"><a className="text-light d-block" href="https://www.v3dataintel.com/home/about.html">About Us</a></li>
                      <li className="mb-3 text-light"><a className="text-light d-block" href="#">Contact Us</a></li>
                      <li className="mb-3 text-light"><a className="text-light d-block" href="https://www.v3dataintel.com/home/licensing.html">Services</a></li>

                    </ul>
                  </div>

                  <div className="col-6 mb-5">
                    <h4 className="text-white mb-2" style={{ fontSize: '1.7rem' }}> Headquarters - USA  </h4>
                    <ul className="list-unstyled">
                      <li className="text-light mb-3">  <b>V3 Data Intelligence Inc</b></li>
                      <li className="text-light mb-3"> Email: info@v3dataintel.com</li>
                      <li className="text-light mb-4"> 28175 Haggerty Road, Novi, Michigan 48377 </li>

                    </ul>

                    <h4 className="text-white mb-2" style={{ fontSize: '1.7rem' }}> Headquarters - INDIA  </h4>
                    <ul className="list-unstyled">
                      <li className="text-light mb-3"> <b>V3 Data Intelligence Inc</b> </li>
                      <li className="text-light mb-3"> Email: info@v3dataintel.com</li>
                      <li className="text-light mb-4">  Akshaya Arcade, 1st Floor, Vellingiri Nagar, Navavoor Pirivu, Coimbatore, 641046 </li>
                    </ul>


                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-secondary-darken py-4">
          <div className="container">
            <div className="row">
              <div className="col-md-6 text-center text-md-left mb-3 mb-md-0">
                <p className="mb-0 text-white"><span className="text-primary"> V3 Data Intelligence</span> &copy; <script>
                  var CurrentYear = new Date().getFullYear()
                  document.write(CurrentYear)
                </script> All Right Reserved</p>
              </div>
              <div className="col-md-6 text-center text-md-right">
                {/* <ul className="list-inline">
                  <li className="list-inline-item mx-0"><a className="d-inline-block px-3 text-white border-right" href="terms-conditions.html">Terms of Service</a></li>
                  <li className="list-inline-item mx-0"><a className="d-inline-block px-3 text-white" href="privacy-policy.html">Privacy Policy</a></li>
                </ul> */}
              </div>
            </div>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default Footer;
